import React from "react"
import { CardDeck, CardColumns, Card, Container, Col, Row } from 'react-bootstrap';
import { Link, graphql} from "gatsby"
import Image from "../components/image.js"
import ResFile from "../components/file.js"

import Layout from "../components/layout"

export const projectQuery = graphql`
  query {
    allMdx(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            titleImage {
            relativePath
            }
            resources {
                binary {
                  res
                  desc
                }
                code {
                  res
                  desc
                }
                github {
                  res
                  desc
                }
                link {
                  res
                  desc
                }
                none {
                  desc
                }
                pdf {
                  res
                  desc
                }
                zip {
                  res
                  desc
                }
            }
            title
            category
            visible
            fullHeight
          }
          fileAbsolutePath
        }
      }
    }
  }
`
const clean = (obj)=> {
  for (let propName in obj) { 
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
}

const Project = ({
    data: {
        allMdx: { edges },
    },
}) => {
    const classes = ['cloud-sky', 'green-sky', 'yellow-sky', 'pink-sky']
    let i = 0
    return (
  <Layout icon="project">
    {"Here's the place I put all my personal projects, research or non-research, big or small, from recent to ancient time..." }
      
      <Container fluid>
      {
          edges
        .filter(edge => {
            return !!edge.node.frontmatter.date && edge.node.frontmatter.category === "project" && edge.node.frontmatter.resources
        }) // You can filter your posts based on some criteria
              .map((edge) => {
                  //TODO
                  const resources = edge.node.frontmatter.resources
                  const fm = edge.node.frontmatter
                  const title = fm.title.toString()
                  const filename = (fm && fm.titleImage) ? fm.titleImage.relativePath : null
                  const titleLimit = 25
                  resources.forEach((v)=>{
                      clean(v)
                  })
                  const height = fm.fullHeight? null : '9rem'
                  return (
                      <Row className={classes[i++%4] } style={{padding: '1rem', marginTop: '1rem', marginBottom: '1rem'}}>
                          
                          <Col md="4" style={{}}>
                              <div style={{width: '100%', height: height, marginLeft: 'auto', marginRight: 'auto', marginTop: '0', overflow: 'hidden'}}>
                                  <Image filename={filename} />
                              </div>
                          </Col>
                      <Col>
                      <Col style={{ border: 'none', borderRadius: '0'}}>
                              <div style={{fontSize: 'x-large', overflow: 'hidden', marginBottom: '0'}}>
                                      {title}
                              </div>
                              <div style={{fontWeight: 200, fontSize: 'medium', overflow: 'hidden'}}>
                                  {edge.node.excerpt.split("\n")[0]}
                              </div>
                              <div className= "links" >
                              {
                                  resources.map((d)=>{
                                      return (
                                          <>
                                              { 
                                                  Object.keys(d).map((k)=> {
                                                      let filename = d[k].res ? d[k].res.split("/").pop() : "#"
                                                      const url = d[k].res
                                                      const desc = d[k].desc
                                                      if(k == 'none' || k == 'link' || k == 'github') {
                                                          filename  = null
                                                      }
                                                      return (
                                                          <ResFile style={{margin: '0.5rem' }} filename={filename} url={url} icon={k} desc={desc}/>
                                                      )
                                                  })
                                              }
                                      </>
                                      )
                                  })
                              }
                          </div>
                              <small style={{color:'#bbb'}}>
                                  {fm.date}
                              </small>
                      </Col>
                  </Col>
                </Row>

                  )
              })
      }
  </Container>
  </Layout>
)
}

export default Project


